import { render, staticRenderFns } from "./useragreement.vue?vue&type=template&id=ce1c0376&scoped=true&"
var script = {}
import style0 from "./useragreement.vue?vue&type=style&index=0&id=ce1c0376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1c0376",
  null
  
)

export default component.exports